import withPageTitle from "../../routes/containers/withPageTitle"
import Profile from "../components/Profile"

export default withPageTitle("My Profile")(Profile)
